import React from "react";
import { Box, FormControlLabel, Checkbox } from "@mui/material";

const CheckboxForm = ({
  orderFormFieldKey,
  orderFormFieldTouched,
  orderFormFieldError,
  nameText,
  value,
  setFieldValue,
  handleBlur,
}) => {
  return (
    <Box
      key={orderFormFieldKey}
      sx={{
        marginTop: "20px",
        width: "100%",
      }}
    >
      <FormControlLabel
        control={
          <Checkbox
            id={orderFormFieldKey}
            name={orderFormFieldKey}
            checked={value === 'false' ? false : Boolean(value)}
            onChange={(e) => {
              setFieldValue(orderFormFieldKey, e.target.checked);
            }}
          />
        }
        label={nameText}
      />
    </Box>
  );
};

export default CheckboxForm;
